// extracted by mini-css-extract-plugin
export var carrierIcon = "_xp-0";
export var carrierLogo = "_xp-1";
export var detailsSection = "_xp-2";